import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Approved: {
    description: 'Display string for the Approved status',
    defaultMessage: 'Approved',
    id: 'lv3YLl',
  },
  AwaitingCompletion: {
    description: 'Display string for the Awaiting Completion status',
    defaultMessage: 'Awaiting Completion',
    id: 'wPHPNg',
  },
  AwaitingDelivery: {
    description: 'Display string for the Awaiting Delivery status',
    defaultMessage: 'Awaiting Delivery',
    id: 'WT8Flg',
  },
  AwaitingExchangeApproval: {
    description: 'Display string for the Awaiting Exchange Approval status',
    defaultMessage: 'Awaiting Exchange Approval',
    id: 'oNUgf2',
  },
  AwaitingExchangeOrderDelivery: {
    description: 'Display string for the Awaiting Exchange Order Delivery status',
    defaultMessage: 'Awaiting Exchange Order Delivery',
    id: 'c6zXEA',
  },
  AwaitingPaymentCompletion: {
    description: 'Display string for the Awaiting Payment Completion status',
    defaultMessage: 'Awaiting Payment Completion',
    id: 'oALSau',
  },
  AwaitingPaymentResolution: {
    description: 'Display string for the Awaiting Payment Resolution status',
    defaultMessage: 'Awaiting Payment Resolution',
    id: 'GDj6id',
  },
  AwaitingPurchaseApproval: {
    description: 'Display string for the Awaiting Purchase Approval status',
    defaultMessage: 'Awaiting Purchase Approval',
    id: 'jwiAf/',
  },
  AwaitingQualificationApproval: {
    description: 'Display string for the Awaiting Qualification Approval status',
    defaultMessage: 'Awaiting Qualification Approval',
    id: 'k/JoYw',
  },
  AwaitingRefundApproval: {
    description: 'Display string for the Awaiting Refund Approval status',
    defaultMessage: 'Awaiting Refund Approval',
    id: 'U0hLjF',
  },
  AwaitingStoreAuthorization: {
    description: 'Display string for the Awaiting Store Authorization status',
    defaultMessage: 'Awaiting Store Authorization',
    id: 'xGbqJC',
  },
  AwaitingWarehouseAuthorization: {
    description: 'Display string for the Awaiting Warehouse Authorization status',
    defaultMessage: 'Awaiting Warehouse Authorization',
    id: 'e4mIjn',
  },
  AwaitingWarehouseReview: {
    description: 'Display string for the Awaiting Warehouse Review status',
    defaultMessage: 'Awaiting Warehouse Review',
    id: '2i5fxV',
  },
  Cancelled: {
    description: 'Display string for the Cancelled status',
    defaultMessage: 'Cancelled',
    id: 'WXL7+x',
  },
  ExchangeRejected: {
    description: 'Display string for the Exchange Rejected status',
    defaultMessage: 'Exchange Rejected',
    id: 'J3krNd',
  },
  ExchangeSuccess: {
    description: 'Display string for the Exchange Success status',
    defaultMessage: 'Exchange Success',
    id: 'O6++cC',
  },
  PurchaseRejected: {
    description: 'Display string for the Purchase Rejected status',
    defaultMessage: 'Purchase Rejected',
    id: 'vqFOdA',
  },
  PurchaseSuccess: {
    description: 'Display string for the Purchase Success status',
    defaultMessage: 'Purchase Success',
    id: 'SK1EuQ',
  },
  QualificationApprovalRejected: {
    description: 'Display string for the Qualification Approval Rejected status',
    defaultMessage: 'Qualification Approval Rejected',
    id: 'DjDc2g',
  },
  RefundRejected: {
    description: 'Display string for the Refund Rejected status',
    defaultMessage: 'Refund Rejected',
    id: 'y+sBof',
  },
  RefundSuccess: {
    description: 'Display string for the Refund Success status',
    defaultMessage: 'Refund Success',
    id: 'Hbaull',
  },
  Rejected: {
    description: 'Display string for the Rejected status',
    defaultMessage: 'Rejected',
    id: '2Cg07R',
  },
  StoreAuthorizationRejected: {
    description: 'Display string for the Store Authorization Rejected status',
    defaultMessage: 'Store Authorization Rejected',
    id: '88Emf2',
  },
  Success: {
    description: 'Display string for the Success status',
    defaultMessage: 'Success',
    id: 'snuz2O',
  },
  WarehouseAuthorizationRejected: {
    description: 'Display string for the Warehouse Authorization Rejected status',
    defaultMessage: 'Warehouse Authorization Rejected',
    id: '69dJ4Z',
  },
});

export const ReturnEntityStatus = {
  Approved: {
    translation: messages.Approved,
    key: 'APPROVED',
  },
  AwaitingCompletion: {
    translation: messages.AwaitingCompletion,
    key: 'AWAITING_COMPLETION',
  },
  AwaitingDelivery: {
    translation: messages.AwaitingDelivery,
    key: 'AWAITING_DELIVERY',
  },
  AwaitingExchangeApproval: {
    translation: messages.AwaitingExchangeApproval,
    key: 'AWAITING_EXCHANGE_APPROVAL',
  },
  AwaitingExchangeOrderDelivery: {
    translation: messages.AwaitingExchangeOrderDelivery,
    key: 'AWAITING_EXCHANGE_ORDER_DELIVERY',
  },
  AwaitingPaymentCompletion: {
    translation: messages.AwaitingPaymentCompletion,
    key: 'AWAITING_PAYMENT_COMPLETION',
  },
  AwaitingPaymentResolution: {
    translation: messages.AwaitingPaymentResolution,
    key: 'AWAITING_PAYMENT_RESOLUTION',
  },
  AwaitingPurchaseApproval: {
    translation: messages.AwaitingPurchaseApproval,
    key: 'AWAITING_PURCHASE_APPROVAL',
  },
  AwaitingQualificationApproval: {
    translation: messages.AwaitingQualificationApproval,
    key: 'AWAITING_QUALIFICATION_APPROVAL',
  },
  AwaitingRefundApproval: {
    translation: messages.AwaitingRefundApproval,
    key: 'AWAITING_REFUND_APPROVAL',
  },
  AwaitingStoreAuthorization: {
    translation: messages.AwaitingStoreAuthorization,
    key: 'AWAITING_STORE_AUTHORIZATION',
  },
  AwaitingWarehouseAuthorization: {
    translation: messages.AwaitingWarehouseAuthorization,
    key: 'AWAITING_WH_AUTHORIZATION',
  },
  AwaitingWarehouseReview: {
    translation: messages.AwaitingWarehouseReview,
    key: 'AWAITING_WH_REVIEW',
  },
  Cancelled: {
    translation: messages.Cancelled,
    key: 'CANCELLED',
  },
  ExchangeRejected: {
    translation: messages.ExchangeRejected,
    key: 'EXCHANGE_REJECTED',
  },
  ExchangeSuccess: {
    translation: messages.ExchangeSuccess,
    key: 'EXCHANGE_SUCCESS',
  },
  PurchaseRejected: {
    translation: messages.PurchaseRejected,
    key: 'PURCHASE_REJECTED',
  },
  PurchaseSuccess: {
    translation: messages.PurchaseSuccess,
    key: 'PURCHASE_SUCCESS',
  },
  QualificationApprovalRejected: {
    translation: messages.QualificationApprovalRejected,
    key: 'QUALIFICATION_APPROVAL_REJECTED',
  },
  RefundRejected: {
    translation: messages.RefundRejected,
    key: 'REFUND_REJECTED',
  },
  RefundSuccess: {
    translation: messages.RefundSuccess,
    key: 'REFUND_SUCCESS',
  },
  Rejected: {
    translation: messages.Rejected,
    key: 'REJECTED',
  },
  StoreAuthorizationRejected: {
    translation: messages.StoreAuthorizationRejected,
    key: 'STORE_AUTHORIZATION_REJECTED',
  },
  Success: {
    translation: messages.Success,
    key: 'SUCCESS',
  },
  WarehouseAuthorizationRejected: {
    translation: messages.WarehouseAuthorizationRejected,
    key: 'WH_AUTHORIZATION_REJECTED',
  },
};
